module.exports = __webpack_public_path__ + "static/media/Asset 2.44f7c7ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Asset 2.svg
// module id = 111
// module chunks = 0